import {Type} from "class-transformer";
import { formatDistanceToNow, format } from 'date-fns';

export class ActivityEvent {
  activity_id: number | undefined;
  table_name: string | undefined;
  fk_id: string | undefined;
  id_user: number | undefined;
  @Type(() => Date)
  c_date: Date | undefined;
  activity_type: ActivityType | undefined;
  severity: string | undefined;
  activity: any | ActivityColumnUpdate | ActivityComment | ActivityAttachment;

  get relativeDate(): string {
    if (!this.c_date) return 'Unknown date';
    return formatDistanceToNow(new Date(this.c_date), { addSuffix: true });
  }

  get shortDate(): string {
    if (!this.c_date) return 'Unknown date';
    return format(this.c_date, 'PP');
  }

  get fullDate(): string {
    if (!this.c_date) return 'Unknown date';
    return format(this.c_date, 'dd/MM/yyyy HH:mm');
  }

  // SOURCE_UPDATE: summary of the changed fields, e.g. "renamed from Amministrazione · now restricted · groups: Direzione, Tecnici"
  get sourceChangesLabel(): string {
    const changes = this.activity?.changes ?? {};
    const parts: string[] = [];
    if (changes.name) parts.push(`renamed from ${changes.name.old}`);
    if (changes.restricted) parts.push(changes.restricted.new ? 'now restricted' : 'no longer restricted');
    if (changes.groups) parts.push(changes.groups.new?.length ? `groups: ${changes.groups.new.join(', ')}` : 'no groups enabled');
    return parts.join(' · ');
  }

  get severityClass(): string {
    switch (this.severity) {
      case 'error': return 'danger';
      case 'warning': return 'warning';
      case 'info': return 'info';
      case 'success': return 'success';
      default: return '';
    }
  }
}

export enum ActivityType {
  RecordCreate = 'RECORD_CREATE',
  RecordUpdate = 'RECORD_UPDATE',
  ColumnUpdate = 'COLUMN_UPDATE',
  AttachmentCreate = 'ATTACHMENT_CREATE',
  AttachmentDelete = 'ATTACHMENT_DELETE',
  Comment = 'COMMENT',
  CommentDelete = 'COMMENT_DELETE',
  DocumentCreate = 'DOCUMENT_CREATE',
  DocumentUpdate = 'DOCUMENT_UPDATE',
  DocumentDelete = 'DOCUMENT_DELETE',
  DocumentsImport = 'DOCUMENTS_IMPORT',
  SourceCreate = 'SOURCE_CREATE',
  SourceDelete = 'SOURCE_DELETE',
  SourceUpdate = 'SOURCE_UPDATE'
}

export class ActivityColumnUpdate {
  label: string | undefined; // display name of the column
  icon?: string | undefined; // display icon
  old?: string | undefined; // old value
  new?: string | undefined; // new value
}

export interface ActivityAttachment {
  filename: string | undefined;
}

export class ActivityComment {
  message: string = '';
}
